import { Combobox, ComboboxButton, ComboboxInput, ComboboxOption, ComboboxOptions } from '@headlessui/react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'
import { useState } from 'react'
import { Coords } from '../utils/types'
import { useDebouncedCallback } from 'use-debounce'
import { useAutocompleteSuggestions } from '../utils/use-autocomplete-suggestions'

interface AddressSearchProps {
    onChangeLatLong?: (coords?: { coords: Coords, address_name: string }) => void
}
export default function AddressSearch(props: AddressSearchProps) {
    const [query, setQuery] = useState('')
    const [selectedLocation, setSelectedLocation] = useState<google.maps.places.AutocompleteSuggestion | null>(null)
    const handleSearch = useDebouncedCallback((text: string) => setQuery(text), 300);
    const { suggestions, resetSession } = useAutocompleteSuggestions(query)
    return (
        <Combobox
            as="div"
            value={selectedLocation}
            onChange={async (location) => {
                const place = location?.placePrediction?.toPlace()
                await place?.fetchFields({ fields: ['location'] })
                setQuery('')
                setSelectedLocation(location)
                const latlng = place?.location?.toJSON()
                props.onChangeLatLong?.(latlng ? {
                    coords: {
                        latitude: Number(latlng?.lat), longitude: Number(latlng?.lng)
                    },
                    address_name: location?.placePrediction?.text.text ?? ''
                } : undefined)
                resetSession()
            }}
        >
            <div className="relative mt-2">
                <ComboboxInput
                    placeholder='Search Address...'
                    className="block w-full rounded-md bg-white py-1.5 pl-3 pr-12 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                    onChange={(event) => handleSearch(event.target.value)}
                    onBlur={() => handleSearch('')}
                    displayValue={(place: google.maps.places.AutocompleteSuggestion) => place?.placePrediction?.text?.text ?? ''}
                />
                <ComboboxButton className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
                    <ChevronUpDownIcon className="size-5 text-gray-400" aria-hidden="true" />
                </ComboboxButton>
                {suggestions.length > 0 && (
                    <ComboboxOptions className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm">
                        {suggestions.map((place) => (
                            <ComboboxOption
                                key={place.placePrediction?.placeId}
                                value={place}
                                className="group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 data-[focus]:bg-indigo-600 data-[focus]:text-white data-[focus]:outline-none">
                                <span className="block truncate group-data-[selected]:font-semibold">{place.placePrediction?.text?.text}</span>
                                <span className="absolute inset-y-0 right-0 hidden items-center pr-4 text-indigo-600 group-data-[selected]:flex group-data-[focus]:text-white">
                                    <CheckIcon className="size-5" aria-hidden="true" />
                                </span>
                            </ComboboxOption>
                        ))}
                    </ComboboxOptions>
                )}
            </div>
        </Combobox>
    )
}

const fetchLocations = async (search: string, places: google.maps.PlacesLibrary) => {
    const auto = new places.AutocompleteSuggestion();
    // // https://nominatim.openstreetmap.org/search?q=Dallas&format=json&countrycodes=US&limit=40
    // const query = new URLSearchParams();
    // query.append('q', search.replaceAll(' ', '+'))
    // query.append('format', 'json');
    // query.append('countrycodes', 'US');
    // query.append('limit', '40');
    // const response = await axios({
    //     method: 'GET',
    //     baseURL: 'https://nominatim.openstreetmap.org/search?' + query.toString(),
    // })
    // return response.data

}